import script from "./Hero.vue?vue&type=script&setup=true&lang=js"
export * from "./Hero.vue?vue&type=script&setup=true&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=048743a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-048743a6"]])

export default __exports__